import { Response } from "react-select-async-paginate";
import AsyncPaginateBootstrap from "../react-select-bootstrap/AsyncPaginateBootstrap";
import { getList } from "../../api/generics";
import { useSelector } from "react-redux";
import { RootState } from "../../store";
import User from "../../models/user";

const RECORS_PER_SEARCH = 20;

type UserSelectProps = {
  value: User | null;
  onChange: (_: User | null) => void;
};

const UserSelect: React.FC<UserSelectProps> = ({ value, onChange }) => {
  const companyId = useSelector(
    (state: RootState) => state.company.data.company.id
  );

  const loadOptions = async (
    s: string,
    currentOpts: readonly (User | { options: User[]; label?: string })[]
  ): Promise<Response<User, { options: User[]; label?: string }, any>> => {
    let additionalParams: Map<string, string> | undefined = new Map<
      string,
      string
    >();

    if (s !== "") {
      additionalParams.set("search", s);
    }

    additionalParams.set("company_id", companyId!.toString());

    const dataPaginated = await getList<User>(
      "/users/",
      RECORS_PER_SEARCH,
      currentOpts.length,
      additionalParams
    );

    let newOpts: User[] = [];
    let count = 0;

    if (dataPaginated.data !== undefined) {
      newOpts = dataPaginated.data.items;
      count = dataPaginated.data.count;
    }

    const hasMore = currentOpts.length + newOpts.length < count;

    return {
      options: newOpts,
      hasMore: hasMore,
    };
  };
  return (
    <AsyncPaginateBootstrap
      placeholder={"Seleccione un Usuario"}
      onChange={onChange}
      isMulti={false}
      debounceTimeout={300}
      loadOptions={loadOptions}
      getOptionLabel={(option: User) => `${option.email}`}
      getOptionValue={(option: User) => `${option.id}`}
      value={value}
      isClearable={true}
    />
  );
};

export default UserSelect;
